import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class RaceLiveStandingStore extends LocalModel {
    constructor() {
        super('raceLiveStanding', {
            namePlural: 'raceLiveStandings',
            namePluralReal: 'racelivestandings',
            sort: 'sortOrder',
            limit: 200,
            api: {
                search: {
                    url: '/api/racelivestandings/',
                    params: {
                        limit: 200,
                        sort: 'sortOrder',
                    },
                },
                load: {
                    url: '/api/racelivestandings/',
                    params: {},
                },
                save: {
                    url: '/api/racelivestandings/',
                    params: {},
                },
                delete: {
                    url: '/api/racelivestandings/',
                    params: {},
                },
            },
        });
    }

    @observable newRaceLiveStanding = {};

    @observable raceLiveStanding = {};

    @observable raceLiveStandings = [];
}

const store = new RaceLiveStandingStore();
export default store;
